import { useCallback, useState } from "react";

const useMobileDialogFilters = () => {
  const [showMobileFiltersDialog, setShowMobileFiltersDialog] = useState<boolean>(false);

  const handleMobileFiltersDialog = useCallback(() => {
    setShowMobileFiltersDialog(!showMobileFiltersDialog);
  }, [showMobileFiltersDialog])

  return {
    showMobileFiltersDialog,
    handleMobileFiltersDialog
  }
}

export default useMobileDialogFilters;